import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import RotatePhonePopup from '../RotatePhonePopup';
import { motion, AnimatePresence } from "framer-motion";
import NoDataFound2 from '../NoData2';
import Nouser from "../../img/NoUserFound.png";
import NouserDark from "../../img/NoUserFoundDark.png";
import { useSnackbar } from "../context/SnackbarContext";

// img
import bgImage from "../../img/frndvoicebg.png"
import meter from "../../img/friendspeedmeter.svg"
import pointer from "../../img/friendpointer.svg"
import btn from "../../img/friendholdbtn.png"
import star from "../../img/star2.png"
import emoji1 from "../../img/friendemoji1.svg"
import emoji2 from "../../img/friendemoji2.svg"
import emoji3 from "../../img/friendemoji3.svg"
import emoji4 from "../../img/friendemoji4.svg"
import emoji5 from "../../img/friendemoji5.svg"
import emoji6 from "../../img/friendemoji6.svg"
import spinWin from "../../audio/spinwin.wav";
import { useLanguage } from '../context/Languagecontext';
import LanguageDropdown from '../Languagedropdown';


const FriendVoice = () => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { username, category } = useParams();
    const [isListening, setIsListening] = useState(false);
    const [isRecording, setIsRecording] = useState(false);
    const [isRecordingComplete, setIsRecordingComplete] = useState(false);
    const [audioBlob, setAudioBlob] = useState(null);
    const [isNavigating, setIsNavigating] = useState(false);
    const [isCheckingPermission, setIsCheckingPermission] = useState(false);
    const [disable, setDisable] = useState(false);
    const [decibel, setDecibel] = useState(0);
    const [activeLottie, setActiveLottie] = useState(null);
    const [angle, setAngle] = useState(-85);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const [imageLoadError, setImageLoadError] = useState(false);
    const [isDarkMode, setIsDarkMode] = useState(
        window.matchMedia('(prefers-color-scheme: dark)').matches
    );
    const [noUserImgSrc, setNoUserImgSrc] = useState(null);
    const [noUserDarkImgSrc, setNoUserDarkImgSrc] = useState(null);
    const [noUserImgLoaded, setNoUserImgLoaded] = useState(false);


    const mediaRecorderRef = useRef(null);
    const audioChunksRef = useRef([]);
    const listeningTimerRef = useRef(null);
    const navigationTimerRef = useRef(null);
    const hasNavigatedRef = useRef(false);
    const streamRef = useRef(null);
    const permissionCheckRef = useRef(false);
    const isRecordingRef = useRef(false);
    const isStartingRecordingRef = useRef(false);

    const recognitionRef = useRef(null);
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const microphoneRef = useRef(null);
    const dataArrayRef = useRef(null);
    const animationFrameRef = useRef(null);
    const recentDecibelsRef = useRef([]);
    const finalDecibelRef = useRef(0);
    const recordingStartTimeRef = useRef(null);
    const spinWinAudioRef = useRef(null);

    const [alertModal, setAlertModal] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });
    const [alertModal2, setAlertModal2] = useState({
        show: false,
        message: '',
        title: 'Alert'
    });

    const { showSnackbar } = useSnackbar();

    const isMobile = () => {
        return window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };

    const showAlert = (message, title = 'Alert') => {
        if (isMobile()) {
            setAlertModal({ show: true, message, title });
        } else {
            setAlertModal({ show: true, message, title });
        }
    };

    const showAlert2 = (message, title = 'Alert') => {
        if (isMobile()) {
            setAlertModal2({ show: true, message, title });
        } else {
            setAlertModal2({ show: true, message, title });
        }
    };

    const isAndroid = /Android/.test(navigator.userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isiOSSafari = isIOS && isSafari;

    const isSmallScreen = window.innerWidth < 380 && window.innerWidth !== 360;

    useEffect(() => {
        spinWinAudioRef.current = new Audio(spinWin);
        spinWinAudioRef.current.preload = "auto";
        spinWinAudioRef.current.loop = false;
        spinWinAudioRef.current.load();
    }, []);


    useEffect(() => {
        if (isRecording && decibel !== null) {
            const newAngle = scoreToAngel(decibel);
            setAngle(newAngle);
        }
    }, [isRecording, decibel]);

    // Get data from location.state or sessionStorage
    const getFlowData = () => {
        const sessionData = sessionStorage.getItem('friendFlowData');
        return sessionData ? JSON.parse(sessionData) : null;
    };

    const flowData = getFlowData();

    useEffect(() => {
        if (!flowData) {
            // console.log('No flow data found, redirecting...');
            navigate(`/${username}/${category}`);
            return;
        }
    }, [flowData, username, category, navigate]);

    const opacity = 0.75;
    const opacity2 = 0.45;
    const hexToRgba = (hex, alpha) => {
        const r = parseInt(hex.slice(1, 3), 16);
        const g = parseInt(hex.slice(3, 5), 16);
        const b = parseInt(hex.slice(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    };

    useEffect(() => {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handleChange = (e) => setIsDarkMode(e.matches);
        mq.addEventListener('change', handleChange);
        return () => mq.removeEventListener('change', handleChange);
    }, []);

    useEffect(() => {
        const imagesToPreload = [
            bgImage, meter, pointer, btn, star,
            emoji1, emoji2, emoji3, emoji4, emoji5, emoji6
        ];

        let loadedCount = 0;
        let hasError = false;
        const totalImages = imagesToPreload.length;

        // Timeout fallback — if images take too long, show error
        const timeoutId = setTimeout(() => {
            if (!hasError) {
                setImageLoadError(true);
            }
        }, 5000);

        const checkAllLoaded = () => {
            loadedCount++;
            if (loadedCount === totalImages) {
                clearTimeout(timeoutId);
                setImagesLoaded(true);
            }
        };

        const handleError = () => {
            if (!hasError) {
                hasError = true;
                clearTimeout(timeoutId);
                setImageLoadError(true);  // ← triggers NoDataFound2
            }
        };

        imagesToPreload.forEach((src) => {
            const img = new Image();
            img.onload = checkAllLoaded;
            img.onerror = handleError;
            img.src = src;
        });

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        let isMounted = true;

        const loadImg = (importedImg, setter, setLoaded) => {
            const img = new Image();
            img.onload = () => {
                if (isMounted) { setter(importedImg); if (setLoaded) setLoaded(true); }
            };
            img.onerror = () => {
                if (isMounted) { setter(importedImg); if (setLoaded) setLoaded(true); }
            };
            img.src = importedImg;
        };

        loadImg(Nouser, setNoUserImgSrc, setNoUserImgLoaded);
        loadImg(NouserDark, setNoUserDarkImgSrc);

        return () => { isMounted = false; };
    }, []);
    // ======================================================

    const getEmojiByAngle = (angle) => {
        if (angle >= -90 && angle <= -70) return emoji1;
        if (angle >= -69 && angle <= -35) return emoji2;
        if (angle >= -34 && angle <= 0) return emoji3;
        if (angle > 0 && angle <= 30) return emoji4;
        if (angle >= 31 && angle <= 60) return emoji5;
        if (angle >= 61 && angle <= 90) return emoji6;
        return emoji3;
    };

    useEffect(() => {

        let initialPermissionState = 'prompt';
        const checkMicPermission = async () => {

            if (permissionCheckRef.current || isCheckingPermission) {
                return;
            }

            permissionCheckRef.current = true;
            setIsCheckingPermission(true);

            try {
                if (navigator.permissions) {
                    try {
                        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
                        initialPermissionState = permissionStatus.state;

                        if (initialPermissionState === 'denied') {
                            if (isAndroid) {
                                showAlert(t?.blockedIOS || "Microphone permission is blocked. To enable:\n1. Tap the three dots (⋮) in browser\n2. Go to Site settings\n3. Tap Microphone\n4. Select 'Allow'");
                            } else if (isiOSSafari) {
                                showAlert2(t?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            } else {
                                showAlert(t?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                            }
                            setIsCheckingPermission(false);
                            permissionCheckRef.current = false;
                            setDisable(true);
                            return;
                        }
                    } catch (permError) {
                        console.log('Permission query not supported');
                    }
                }

                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

                // Store the stream for later use instead of stopping it
                streamRef.current = stream;

                // Set up audio context for decibel measurement
                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                analyserRef.current = audioContextRef.current.createAnalyser();
                analyserRef.current.fftSize = 2048;
                const micSource = audioContextRef.current.createMediaStreamSource(stream);
                micSource.connect(analyserRef.current);

                setIsCheckingPermission(false);

                setIsCheckingPermission(false);

            } catch (error) {
                console.error('Microphone permission error:', error);
                setIsCheckingPermission(false);
                permissionCheckRef.current = false;

                if (error.name === 'NotAllowedError') {
                    if (navigator.permissions) {
                        try {
                            const permissionStatus = await navigator.permissions.query({ name: 'microphone' });

                            if (permissionStatus.state === 'denied' && initialPermissionState === 'denied') {
                                if (isAndroid) {
                                    showAlert(t?.blockedIOS || "Microphone permission is blocked. To enable:\n1. Tap the three dots (⋮) in browser\n2. Go to Site settings\n3. Tap Microphone\n4. Select 'Allow'");
                                } else if (isiOSSafari) {
                                    showAlert2(t?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                } else {
                                    showAlert(t?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                }
                                setDisable(true);
                            } else {
                                if (isiOSSafari) {
                                    let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;
                                    micDeniedCount += 1;
                                    sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());

                                    if (micDeniedCount >= 3) {
                                        showAlert2(t?.blockedIOS || "Microphone permission is blocked. Please enable it in your browser settings.");
                                    } else {
                                        showAlert2(t?.whoTalkin.blockedIOS || "Microphone permission is blocked.");
                                    }
                                } else {
                                    showAlert(t?.whoTalkin.micNotFound || "No microphone found on your device.");
                                }
                                setDisable(true);
                            }
                        } catch (permError) {
                            if (isiOSSafari) {
                                let micDeniedCount = parseInt(sessionStorage.getItem('micDeniedCount'), 10) || 0;
                                micDeniedCount += 1;
                                sessionStorage.setItem('micDeniedCount', micDeniedCount.toString());

                                if (micDeniedCount >= 3) {
                                    showAlert2(t?.whoTalkin.blockedIOS || "Microphone permission is blocked.");
                                } else {
                                    showAlert2(t?.whoTalkin.blockedIOS || "Microphone permission is blocked.");
                                }
                            } else {
                                showAlert(t?.whoTalkin.micNotFound || "No microphone found on your device.");
                            }
                            setDisable(true);
                        }
                    }
                } else if (error.name === 'NotFoundError') {
                    showAlert(t?.whoTalkin.micNotFound || "No microphone found on your device.");
                    setDisable(true);
                } else if (error.name === 'NotReadableError' || error.name === 'TrackStartError') {
                    showAlert(t?.whoTalkin.micInUse || "Microphone is being used by another application.");
                    setDisable(true);
                }
            }
        };

        checkMicPermission();

        return () => {
            // console.log("Component unmounting, cleaning up...");

            if (navigationTimerRef.current) {
                clearTimeout(navigationTimerRef.current);
                navigationTimerRef.current = null;
            }
            if (listeningTimerRef.current) {
                clearTimeout(listeningTimerRef.current);
                listeningTimerRef.current = null;
            }
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }

            // Stop MediaRecorder
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                try {
                    mediaRecorderRef.current.stop();
                } catch (e) { }
                mediaRecorderRef.current = null;
            }

            // Disconnect audio nodes
            if (microphoneRef.current) {
                try {
                    microphoneRef.current.disconnect();
                } catch (e) { }
                microphoneRef.current = null;
            }

            if (analyserRef.current) {
                try {
                    analyserRef.current.disconnect();
                } catch (e) { }
                analyserRef.current = null;
            }

            // Close audio context synchronously (don't await)
            if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
                audioContextRef.current.close().catch(e =>
                    console.warn("Error closing audio context:", e)
                );
                audioContextRef.current = null;
            }

            // Stop all media tracks
            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => {
                    track.stop();
                    // console.log("Track stopped on unmount:", track.kind, track.readyState);
                });
                streamRef.current = null;
            }

            // Reset all flags
            isStartingRecordingRef.current = false;
            isRecordingRef.current = false;
            hasNavigatedRef.current = false;
            permissionCheckRef.current = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty dependency array - runs only on mount/unmount

    useEffect(() => {
        const handlePopState = (event) => {
            // console.log("Back button pressed - cleaning up audio resources");

            // Immediate cleanup for back navigation
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }

            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
            }

            if (audioContextRef.current) {
                audioContextRef.current.close().catch(() => { });
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // console.log("Tab hidden/minimized - stopping microphone");

                // Stop recording if active
                if (isRecordingRef.current) {
                    isRecordingRef.current = false;
                    setIsRecording(false);
                    setDecibel(0);
                    setAngle(-85); // Reset angle to initial
                    setActiveLottie(null);
                    isStartingRecordingRef.current = false;
                }

                // Cancel animation frame
                if (animationFrameRef.current) {
                    cancelAnimationFrame(animationFrameRef.current);
                    animationFrameRef.current = null;
                }

                // Stop MediaRecorder
                if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                    try {
                        mediaRecorderRef.current.stop();
                    } catch (e) { }
                    mediaRecorderRef.current = null;
                }

                // Stop all stream tracks (releases mic indicator in browser/Safari)
                if (streamRef.current) {
                    streamRef.current.getTracks().forEach(track => track.stop());
                    streamRef.current = null;
                }

                // Close audio context
                if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
                    audioContextRef.current.close().catch(e => console.warn("Audio context close error:", e));
                    audioContextRef.current = null;
                }

                // Reset refs
                recentDecibelsRef.current = [];
                recordingStartTimeRef.current = null;
                audioChunksRef.current = [];
                permissionCheckRef.current = false;
            }
            // No else needed — stream is recreated in startListening() when user returns
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    useEffect(() => {
        const isDisabled = isRecording || isCheckingPermission || isNavigating || !!activeLottie;
        window.dispatchEvent(new CustomEvent('dropdownDisabledState', {
            detail: { disabled: isDisabled }
        }));
    }, [isRecording, isCheckingPermission, isNavigating, activeLottie]);

    const navigateToNextScreen = async () => {
        if (hasNavigatedRef.current || isNavigating) return;

        hasNavigatedRef.current = true;
        setIsNavigating(true);

        try {
            // console.log("Starting cleanup before navigation...");

            // --- cleanup logic ---
            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                mediaRecorderRef.current.stop();
                await new Promise(resolve => setTimeout(resolve, 100));
                mediaRecorderRef.current = null;
            }

            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }

            if (microphoneRef.current) {
                microphoneRef.current.disconnect();
                microphoneRef.current = null;
            }

            if (analyserRef.current) {
                analyserRef.current.disconnect();
                analyserRef.current = null;
            }

            if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
                await audioContextRef.current.close();
                audioContextRef.current = null;
            }

            if (streamRef.current) {
                streamRef.current.getTracks().forEach(track => track.stop());
                streamRef.current = null;
                await new Promise(resolve => setTimeout(resolve, 300));
            }

        } catch (error) {
            console.error("Error during cleanup:", error);
            await new Promise(resolve => setTimeout(resolve, 300));
        }

        // ====== NEW: CLEAR ALL COMPONENT STATE ======
        setDecibel(0);
        setIsListening(false);
        setIsRecording(false);
        setActiveLottie(null);
        setIsRecordingComplete(false);
        setIsCheckingPermission(false);
        setDisable(false);
        setAngle(-80);

        // ====== NEW: CLEAR ALL REFS ======
        recentDecibelsRef.current = [];
        finalDecibelRef.current = 0;
        recordingStartTimeRef.current = null;
        audioChunksRef.current = [];
        isRecordingRef.current = false;
        isStartingRecordingRef.current = false;
        permissionCheckRef.current = false;

        window.scrollTo(0, 0);

        // ====== NEW: NAVIGATE WITH REPLACE OPTION ======
        navigate(`/${username || ''}/${category || ''}/friendcard`, {
            replace: false
        });
    };

    const measureLoudness = () => {
        if (!analyserRef.current || !isRecordingRef.current) {
            animationFrameRef.current = null;
            return;
        }

        try {
            const bufferLength = analyserRef.current.fftSize;
            if (!dataArrayRef.current || dataArrayRef.current.length !== bufferLength) {
                dataArrayRef.current = new Uint8Array(bufferLength);
            }

            analyserRef.current.getByteTimeDomainData(dataArrayRef.current);

            let sum = 0;
            for (let i = 0; i < bufferLength; i++) {
                const value = (dataArrayRef.current[i] - 128) / 128;
                sum += value * value;
            }

            const rms = Math.sqrt(sum / bufferLength);
            const scaledRms = rms * 2;
            const dB = scaledRms > 0 ? 20 * Math.log10(scaledRms) : -100;
            const peakScore = calculateScore(dB);
            const scoreValue = parseFloat(peakScore.toFixed(0));

            setDecibel(scoreValue);

            recentDecibelsRef.current.push(parseFloat(dB.toFixed(2)));
            if (recentDecibelsRef.current.length > 20) {
                recentDecibelsRef.current.shift();
            }

            if (isRecordingRef.current) {
                animationFrameRef.current = requestAnimationFrame(measureLoudness);
            } else {
                animationFrameRef.current = null;
            }
        } catch (error) {
            console.warn('Error in measureLoudness:', error);
            animationFrameRef.current = null;
        }
    };

    const calculateScore = (dB) => {
        const db = parseFloat(dB);
        let score = 0;

        if (db <= -50) score = 0;

        else if (db > -50 && db <= -40)
            score = ((db + 50) / 10) * 11;          // middle between 10 & 12

        else if (db > -40 && db <= -30)
            score = ((db + 40) / 10) * 16 + 11;     // middle between (15+10) & (18+12)

        else if (db > -30 && db <= -20)
            score = ((db + 30) / 10) * 22 + 28;     // middle between (20+25) & (25+30)

        else if (db > -20 && db <= -12)
            score = ((db + 20) / 8) * 18 + 50;      // middle between (15+45) & (20+55)

        else if (db > -12 && db <= -6)
            score = ((db + 12) / 6) * 27 + 68;      // middle between (25+60) & (30+75)

        else if (db > -6)
            score = 87 + (db + 6) * 5.5;            // middle between both formulas

        return Math.min(100, Math.round(score));
    };


    const scoreToAngel = (score) => {
        const s = Math.max(0, Math.min(100, score)); // clamp

        if (s <= 50) {
            // 0–50  →  -90–0
            return (s / 50) * 90 - 90;
        } else {
            // 50–100 → 0–90
            return ((s - 50) / 50) * 90;
        }
    };

    const handlePressStart = async (e) => {
        e.preventDefault();
        e.stopPropagation(); // Add this to prevent event bubbling

        // console.log("=== PRESS START ===");
        // console.log("Current state:", {
        //     isRecording,
        //     isRecordingComplete,
        //     isNavigating,
        //     isCheckingPermission,
        //     disable,
        //     isStarting: isStartingRecordingRef.current
        // });

        // Check internet connection
        if (!navigator.onLine) {
            showSnackbar(t?.common?.nointertoast || "Please turn on internet connection!", "error");
            return;
        }

        // Check microphone permission
        // if (!micPermissionGranted) {
        //     setSnackbar({
        //         show: true,
        //         message: t?.emotion?.permissionError || "Microphone permission not granted. Please allow access.",
        //         type: 'error'
        //     });
        //     setTimeout(() => {
        //         setSnackbar({ show: false, message: '', type: 'error' });
        //     }, 3000);
        //     return;
        // }

        // Check if already recording or disabled
        if (isRecording || isRecordingComplete || isNavigating || isCheckingPermission || disable) {
            // console.log("Action blocked - already in progress or disabled");
            return;
        }

        // Prevent multiple rapid clicks - CRITICAL FIX
        if (isStartingRecordingRef.current) {
            // console.log("Already starting recording, ignoring duplicate event");
            return;
        }

        isStartingRecordingRef.current = true;
        // console.log("Set isStartingRecordingRef to true");

        try {
            await startListening();
        } catch (error) {
            console.error("Error in handlePressStart:", error);
            // IMPORTANT: Reset the flag on error
            isStartingRecordingRef.current = false;

            showSnackbar(t?.emotion?.recordError || "Error starting recording. Please try again.", "error");
        }
    };
    const handlePressEnd = (e) => {
        e.preventDefault();
        e.stopPropagation(); // Add this to prevent event bubbling

        // console.log("=== PRESS END ===");
        // console.log("isRecording:", isRecording);
        // console.log("isStartingRecordingRef:", isStartingRecordingRef.current);

        // Only stop if actually recording
        if (isRecording && !isRecordingComplete && !isNavigating) {
            // console.log("Stopping recording...");
            stopListening();
        } else {
            // console.log("Not stopping - not in recording state");
            // Reset the starting flag if we're not recording
            isStartingRecordingRef.current = false;
        }
    };

    const startListening = async () => {
        // console.log("=== START LISTENING ===");

        // if (!micPermissionGranted) {
        //     isStartingRecordingRef.current = false; // Reset flag
        //     setSnackbar({
        //         show: true,
        //         message: t?.emotion?.permissionError || "Microphone permission not granted. Please allow access.",
        //         type: 'error'
        //     });
        //     setTimeout(() => {
        //         setSnackbar({ show: false, message: '', type: 'error' });
        //     }, 3000);
        //     return;
        // }

        try {
            // DON'T recreate stream if it's already active - this was causing delays
            if (!streamRef.current || !streamRef.current.active) {
                // console.log("Stream not available or inactive, recreating...");

                const newStream = await navigator.mediaDevices.getUserMedia({ audio: true });
                streamRef.current = newStream;

                if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
                    await audioContextRef.current.close();
                }

                audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
                analyserRef.current = audioContextRef.current.createAnalyser();
                analyserRef.current.fftSize = 2048;
                const micSource = audioContextRef.current.createMediaStreamSource(newStream);
                micSource.connect(analyserRef.current);
            } else {
                // console.log("Using existing active stream");

                // Resume audio context if suspended (important for iOS)
                if (audioContextRef.current && audioContextRef.current.state === 'suspended') {
                    // console.log("Resuming suspended audio context");
                    await audioContextRef.current.resume();
                }
            }

            const mediaRecorder = new MediaRecorder(streamRef.current);
            mediaRecorderRef.current = mediaRecorder;
            audioChunksRef.current = [];

            const mimeType = MediaRecorder.isTypeSupported('audio/webm') ? 'audio/webm' :
                MediaRecorder.isTypeSupported('audio/mp4') ? 'audio/mp4' : 'audio/webm';

            recordingStartTimeRef.current = Date.now();
            // console.log("Recording start time set:", recordingStartTimeRef.current);

            mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    audioChunksRef.current.push(event.data);
                    // console.log("Audio chunk added, size:", event.data.size);
                }
            };

            mediaRecorder.onstop = async () => {
                // console.log("=== MEDIA RECORDER STOPPED ===");
                const recordingDuration = (Date.now() - recordingStartTimeRef.current) / 1000;
                // console.log("Recording duration:", recordingDuration, "seconds");

                if (recordingDuration < 1) {
                    // console.log("Recording too short!");

                    // Reset states
                    isStartingRecordingRef.current = false;
                    setIsRecording(false);
                    isRecordingRef.current = false;

                    showSnackbar(t?.emotion?.recordError || "Please hold and press longer.", "error");
                    return;
                }

                const blob = new Blob(audioChunksRef.current, { type: mimeType });
                // console.log("Created blob, size:", blob.size);

                setIsRecordingComplete(true);

                setAudioBlob(blob);

                // Show animation before navigation
                if (!isIOS) {
                    navigationTimerRef.current = setTimeout(() => {
                        navigateToNextScreen();
                    }, 800);
                }

            };

            mediaRecorder.onerror = (error) => {
                console.error("MediaRecorder error:", error);
                isStartingRecordingRef.current = false;
                setIsRecording(false);
                isRecordingRef.current = false;
            };

            // Start recording
            mediaRecorder.start();
            // console.log("MediaRecorder started");

            // Update states AFTER successful start
            setIsRecording(true);
            isRecordingRef.current = true;
            setDecibel(0);
            setActiveLottie(null);

            // Reset the starting flag now that recording has successfully started
            isStartingRecordingRef.current = false;
            // console.log("Reset isStartingRecordingRef to false after successful start");

            measureLoudness();

        } catch (error) {
            console.error('Error starting recording:', error);

            // Reset flag on error
            isStartingRecordingRef.current = false;

            showSnackbar(t?.emotion?.recordError || "Error starting recording. Please try again.", "error");
        }
    };

    // Update the stopListening function
    const stopListening = () => {
        if (hasNavigatedRef.current || isNavigating) {
            // console.log("Already navigating, skipping stopListening");
            return;
        }

        // console.log("=== STOP LISTENING ===");
        const wasRecording = isRecordingRef.current;
        isRecordingRef.current = false;
        setIsRecording(false);

        const recordingDuration = recordingStartTimeRef.current
            ? (Date.now() - recordingStartTimeRef.current) / 1000
            : 0;

        // console.log("Recording duration:", recordingDuration, "seconds");

        const cleanupRecording = () => {
            // console.log("Cleaning up recording resources...");

            if (listeningTimerRef.current) {
                clearTimeout(listeningTimerRef.current);
                listeningTimerRef.current = null;
            }

            if (navigationTimerRef.current) {
                clearTimeout(navigationTimerRef.current);
                navigationTimerRef.current = null;
            }

            if (mediaRecorderRef.current && mediaRecorderRef.current.state !== 'inactive') {
                try {
                    // console.log("Stopping MediaRecorder, state:", mediaRecorderRef.current.state);
                    mediaRecorderRef.current.stop();
                } catch (err) {
                    // console.warn('Error stopping media recorder:', err);
                    mediaRecorderRef.current = null;
                    recordingStartTimeRef.current = null;
                }
            } else {
                // console.log("MediaRecorder already inactive or null");
                recordingStartTimeRef.current = null;
            }

            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
                animationFrameRef.current = null;
            }

            if (recognitionRef.current) {
                try {
                    // console.log("Stopping speech recognition");
                    recognitionRef.current.stop();
                } catch (err) {
                    console.warn('Error stopping recognition:', err);
                }
                recognitionRef.current = null;
            }

            if (microphoneRef.current) {
                try {
                    microphoneRef.current.disconnect();
                } catch (err) {
                    console.warn('Error disconnecting microphone:', err);
                }
                microphoneRef.current = null;
            }

            // console.log("Keeping stream alive for next recording");
            setIsListening(false);
            // console.log("Cleanup complete");
        };

        // Check if recording was too short
        if (!wasRecording || recordingDuration < 1) {
            // console.log("Recording too short or never started:", recordingDuration);

            cleanupRecording();
            isStartingRecordingRef.current = false;
            setDecibel(0);
            setActiveLottie(null);
            setAngle(-80); // Reset angle to initial position

            showSnackbar(t?.emotion?.recordError || "Please hold and press longer.", "error");

            setTimeout(() => {
                recordingStartTimeRef.current = null;
                if (mediaRecorderRef.current) {
                    mediaRecorderRef.current = null;
                }
            }, 100);

            return;
        }

        // console.log("Normal stop, cleaning up...");
        cleanupRecording();

        // Get last 2 seconds of decibel readings, or 1 second before end if recording > 2 seconds
        const readingsPerSecond = 60; // approximate frame rate
        let currentDecibel;

        if (recentDecibelsRef.current.length > 0) {
            let relevantReadings;

            if (recordingDuration <= 2) {
                // Recording is 2 seconds or less - use last 2 seconds (all available data)
                const samplesToUse = Math.min(readingsPerSecond * 2, recentDecibelsRef.current.length);
                const endIndex = recentDecibelsRef.current.length - 5; // Exclude last 5 frames (~83ms)
                const startIndex = Math.max(0, endIndex - samplesToUse);
                relevantReadings = recentDecibelsRef.current.slice(startIndex, endIndex);
                // console.log(`Recording ≤2s (${recordingDuration.toFixed(2)}s): Using last ${relevantReadings.length} samples`);
            } else {
                // Recording is more than 2 seconds - use 1 second before the end
                const onSecondSamples = readingsPerSecond;
                const endIndex = recentDecibelsRef.current.length - 5; // Exclude last 5 frames
                const startIndex = Math.max(0, endIndex - onSecondSamples);
                relevantReadings = recentDecibelsRef.current.slice(startIndex, endIndex);
                // console.log(`Recording >2s (${recordingDuration.toFixed(2)}s): Using 1 second before end (${relevantReadings.length} samples)`);
            }

            if (relevantReadings.length > 0) {
                // Calculate average dB from relevant readings
                const avgDb = relevantReadings.reduce((sum, db) => sum + db, 0) / relevantReadings.length;
                currentDecibel = calculateScore(avgDb);

                // console.log("Averaged decibel:", currentDecibel, "from", relevantReadings.length, "samples");
            } else {
                // Fallback to current decibel if no samples available
                currentDecibel = parseFloat(decibel) || 0;
                // console.log("No samples available, using current decibel:", currentDecibel);
            }
        } else {
            // Fallback to current decibel if no readings
            currentDecibel = parseFloat(decibel) || 0;
            // console.log("No decibel readings, using current decibel:", currentDecibel);
        }

        if (currentDecibel < 10) {
            currentDecibel = 10;
            setDecibel(10);
        }

        finalDecibelRef.current = currentDecibel;
        let newActiveLottie = null;

        // Set final angle based on final decibel
        const finalAngle = scoreToAngel(currentDecibel);
        setAngle(finalAngle);
        if (finalAngle >= -90 && finalAngle < -30) {
            newActiveLottie = "low";
        } else if (finalAngle >= -30 && finalAngle <= 30) {
            newActiveLottie = "medium";
        } else if (finalAngle > 30 && finalAngle <= 90) {
            newActiveLottie = "high";
        }
        setActiveLottie(newActiveLottie);
        if (isIOS) {
            setTimeout(() => {
                try {
                    if (navigator.onLine && spinWinAudioRef.current) {
                        spinWinAudioRef.current.currentTime = 0;
                        spinWinAudioRef.current.play();
                    }
                } catch (e) {
                    console.warn("Win audio error:", e);
                }
            }, 1100);
        }
    };


    if (!imagesLoaded) {
        return (
            <div
                className='GTRegular d-flex justify-content-center align-items-center'
                style={{
                    background: flowData?.gradientBg || '#fff',
                    height: '100dvh'
                }}
            >

            </div>
        );
    }

    if (imageLoadError) {
        const currentNoUserImg = isDarkMode ? noUserDarkImgSrc : noUserImgSrc;
        return (
            <NoDataFound2
                style={{ height: '100vh' }}
                t={t?.noData2 || {}}
                Nouser={currentNoUserImg}
                username={username}
                category={category}
                imgLoaded={noUserImgLoaded}
            />
        );
    }

    return (
        <div
            className='GTRegular'
            style={{ background: flowData.gradientBg, height: '100dvh' }}
        >
            <div className='h-100 d-flex justify-content-center'>
                <Row className='h-100'
                    style={{ width: "450px", maxWidth: "100vw" }}>
                    <Col className="p-0 d-flex flex-column" style={{ height: '100%' }}>
                        <div
                            className="d-flex justify-content-center align-items-end"
                            style={{ height: isSmallScreen ? '95px' : '95px' }}
                        >
                            <div className="text-center w-75">
                                <p
                                    className="lh-sm mx-auto ps-2 m-0 pt-2"
                                    style={{
                                        fontSize: "clamp(14px, 4.5vw, 21px)",
                                        color: "#000"
                                    }}
                                >
                                    {t?.friend?.voiceTitle1 || "Say it loud & prove it anonymously"}
                                </p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100 my-1">
                            <div className="h-100 w-100 d-flex justify-content-center align-items-center flex-column">
                                <div
                                    className="rounded-5 overflow-hidden"
                                    style={{
                                        width: isSmallScreen ? "87%" : "90%",
                                        height: isSmallScreen ? "380px" : "430px",
                                        minHeight: isSmallScreen ? "350px" : "430px",
                                        maxHeight: "90%",
                                        border: "2px solid black",
                                        backgroundImage: `url(${bgImage})`,
                                        backgroundSize: "contain",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                    }}
                                >
                                    <div
                                        className="rounded-5 overflow-hidden"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            background: "rgba(255 , 255 , 255 , 0.4)",
                                            backdropFilter: "blur(18px)",
                                            WebkitBackdropFilter: "blur(18px)", // Safari
                                        }}
                                    >
                                        <div className="d-flex justify-content-center align-items-center" style={{ flex: 1 }}>
                                            <div
                                                className="d-flex justify-content-center align-items-center position-relative"
                                                style={{ width: "95%", height: "100%" }}
                                            >

                                                {/* Pointer */}
                                                <div
                                                    className="position-absolute"
                                                    style={{
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%) translateY(20px)",
                                                        zIndex: 3,
                                                    }}
                                                >
                                                    <img
                                                        src={pointer}
                                                        alt="pointer"
                                                        className="auto-pointer"
                                                        style={{
                                                            width: "16px",
                                                            transform: `rotate(${angle}deg)`,
                                                            transformOrigin: "bottom center",
                                                        }}
                                                    />
                                                </div>

                                                {/* Meter */}
                                                <div
                                                    className="position-absolute d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: "101%",
                                                        height: "auto",
                                                        bottom: isSmallScreen ? "22%" : "24%",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                    }}
                                                >
                                                    <img
                                                        src={meter}
                                                        alt="meter"
                                                        style={{
                                                            width: "100%",
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </div>

                                                <div
                                                    className="position-absolute d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: isSmallScreen ? "135px" : "145px",
                                                        height: "90px",
                                                        bottom: isSmallScreen ? "20%" : "22.5%",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                    }}
                                                >
                                                    <svg
                                                        width="100%"
                                                        height="100%"
                                                        viewBox="0 0 160 76"
                                                        preserveAspectRatio="xMidYMid meet"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        style={{ opacity: 0.6 }}
                                                    >
                                                        <path d="M9.82952 85.5C4.11012 85.5 -0.587442 80.8485 0.059841 75.1658C2.20899 56.2979 10.1995 38.6215 22.9051 25.0424C37.908 9.00801 58.2563 2.43278e-06 79.4736 0C100.691 -2.43278e-06 121.039 9.008 136.042 25.0424C148.748 38.6215 156.738 56.2979 158.887 75.1658C159.535 80.8485 154.837 85.5 149.118 85.5V85.5C143.398 85.5 138.844 80.8363 137.971 75.1839C135.967 62.2038 130.214 50.118 121.397 40.6947C110.278 28.8116 95.1978 22.1357 79.4736 22.1357C63.7494 22.1357 48.6692 28.8116 37.5505 40.6947C28.7334 50.118 22.9802 62.2038 20.9762 75.1839C20.1035 80.8363 15.5489 85.5 9.82952 85.5V85.5Z"
                                                            fill={flowData?.bg || "#fff"} />
                                                    </svg>

                                                </div>

                                                {/* Center Circle / SVG */}
                                                <div
                                                    className="position-absolute rounded-circle"
                                                    style={{
                                                        width: "30px",
                                                        height: "30px",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate(-50%, -50%) translateY(75px)",
                                                        zIndex: 4,

                                                    }}
                                                >
                                                    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M7.25042 2.15458C14.3404 -2.11247 23.565 0.148044 27.8343 7.25981C29.3844 9.82512 30.0705 12.6444 29.9943 15.4383C29.8418 20.3658 27.2752 25.1154 22.7518 27.8331C15.6618 32.1256 6.43723 29.8397 2.16799 22.7533C-2.12666 15.6415 0.160429 6.44704 7.25042 2.15458Z" fill="url(#paint0_linear_458_499)" />
                                                        <defs>
                                                            <linearGradient id="paint0_linear_458_499" x1="15" y1="30" x2="15" y2="3.20374e-07" gradientUnits="userSpaceOnUse">
                                                                <stop />
                                                                <stop offset="1" stop-color="#666666" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>

                                                </div>

                                                <div
                                                    className="position-absolute GTBold"
                                                    style={{
                                                        bottom: isSmallScreen ? "11%" : "16%",
                                                        left: "12%",
                                                        transform: "translateX(-50%)",
                                                        zIndex: 3,
                                                        fontSize: "18px"
                                                    }}
                                                >
                                                    {t?.friend?.low || "Low"}
                                                </div>

                                                <div
                                                    className="position-absolute GTBold"
                                                    style={{
                                                        bottom: isSmallScreen ? "11%" : "16%",
                                                        right: "0%",
                                                        transform: "translateX(-50%)",
                                                        zIndex: 3,
                                                        fontSize: "18px"
                                                    }}
                                                >
                                                    {t?.friend?.high || "High"}
                                                </div>

                                                <div
                                                    className="position-absolute GTBold"
                                                    style={{
                                                        top: isSmallScreen ? "7%" : "13%",
                                                        left: "50%",
                                                        transform: "translateX(-50%)",
                                                        zIndex: 3,
                                                        fontSize: "18px"
                                                    }}
                                                >
                                                    {t?.friend?.medium || "Medium"}
                                                </div>
                                            </div>

                                        </div>

                                        {/* bottom content */}
                                        <div
                                            className="d-flex justify-content-center align-items-center GTMedium"
                                            style={{
                                                height: "80px",
                                                fontSize: "20px",
                                                flexShrink: 0,
                                                background: `linear-gradient(to right,${hexToRgba(flowData.bg, opacity)},${hexToRgba(flowData.bg, opacity2)} )`,
                                            }}
                                        >
                                            {flowData.name}
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>

                        <div
                            className="d-flex justify-content-center align-items-center"
                            style={{ height: isSmallScreen ? '120px' : '150px' }}
                        >
                            <div
                                className={`press-image-btn mx-auto Pure2 d-flex align-items-start justify-content-center px-4 text-white text-center ${isListening ? "recording" : ""}`}
                                onMouseDown={handlePressStart}
                                onMouseUp={handlePressEnd}
                                onMouseLeave={handlePressEnd}
                                onTouchStart={(e) => {
                                    // Prevent iOS from treating this as a click
                                    e.preventDefault();
                                    handlePressStart(e);
                                }}
                                onTouchEnd={(e) => {
                                    e.preventDefault();
                                    handlePressEnd(e);
                                }}
                                onTouchCancel={(e) => {
                                    // Handle touch cancel (when user drags finger away)
                                    e.preventDefault();
                                    handlePressEnd(e);
                                }}
                                // onClick={() => setActiveLottie("love")}
                                style={{
                                    width: isSmallScreen ? "95px" : "115px",
                                    height: isSmallScreen ? "95px" : "115px",
                                    flex: "0 0 63%",
                                    fontSize: isSmallScreen ? "20px" : "23px",
                                    paddingTop: isSmallScreen ? "19px" : "26px",
                                    lineHeight: "20px",
                                    backgroundImage: `url(${btn})`,
                                    backgroundSize: "contain",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                    cursor: isRecordingComplete || isNavigating || disable
                                        ? "not-allowed"
                                        : "pointer",
                                    userSelect: "none",
                                    opacity: isRecordingComplete || disable ? 0.8 : 1,
                                    transition: "all 0.2s",
                                    WebkitTouchCallout: "none",
                                    WebkitUserSelect: "none",
                                    WebkitTapHighlightColor: "transparent", // Prevent iOS tap highlight
                                    touchAction: "none", // Prevent default touch actions
                                    pointerEvents: isRecordingComplete || isNavigating || disable
                                        ? "none"
                                        : "auto"
                                }}
                            >
                                {t?.friend?.hold || "HOLD & SHOUT"}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>

            <RotatePhonePopup
                excludeWhen={[]}
            />

            {/* Fullscreen Emotion Animation */}
            <AnimatePresence>
                {activeLottie && isIOS && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.5, delay: 1 }}
                        className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                        style={{
                            zIndex: 99999,
                            backgroundColor: 'rgba(0, 0, 0, 0.8)',
                            backdropFilter: 'blur(5px)',
                            overflow: 'hidden'
                        }}
                    >
                        {/* Star animations - keeping all existing star animations */}
                        <motion.img
                            src={star}
                            alt="star"
                            width={35}
                            className="position-absolute"
                            style={{ top: '50%', left: '15%' }}
                            animate={{
                                x: [0, 15, -10, 8, -5, 0],
                                y: [0, -8, 6, -4, 3, 0],
                                rotate: [0, 10, -10, 5, -5, 0]
                            }}
                            transition={{
                                duration: 5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut"
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={20}
                            className="position-absolute"
                            style={{ top: '55%', right: '10%' }}
                            animate={{
                                x: [0, -12, 8, -6, 4, 0],
                                y: [0, 10, -7, 5, -3, 0],
                                rotate: [0, -15, 15, -8, 8, 0]
                            }}
                            transition={{
                                duration: 6,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 0.5
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={6}
                            className="position-absolute"
                            style={{ bottom: '65%', left: '12%' }}
                            animate={{
                                x: [0, 10, -8, 6, -4, 0],
                                y: [0, -12, 9, -6, 4, 0],
                                rotate: [0, 20, -20, 10, -10, 0]
                            }}
                            transition={{
                                duration: 7,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 1
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={35}
                            className="position-absolute"
                            style={{ top: '30%', right: '35%' }}
                            animate={{
                                x: [0, 15, -10, 8, -5, 0],
                                y: [0, -8, 6, -4, 3, 0],
                                rotate: [0, 10, -10, 5, -5, 0]
                            }}
                            transition={{
                                duration: 5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut"
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={10}
                            className="position-absolute"
                            style={{ top: '35%', right: '10%' }}
                            animate={{
                                x: [0, -12, 8, -6, 4, 0],
                                y: [0, 10, -7, 5, -3, 0],
                                rotate: [0, -15, 15, -8, 8, 0]
                            }}
                            transition={{
                                duration: 6,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 0.5
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={6}
                            className="position-absolute"
                            style={{ top: '25%', right: '12%' }}
                            animate={{
                                x: [0, 10, -8, 6, -4, 0],
                                y: [0, -12, 9, -6, 4, 0],
                                rotate: [0, 20, -20, 10, -10, 0]
                            }}
                            transition={{
                                duration: 7,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 1
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={10}
                            className="position-absolute"
                            style={{ bottom: '35%', right: '15%' }}
                            animate={{
                                x: [0, -15, 10, -8, 5, 0],
                                y: [0, -10, 8, -5, 3, 0],
                                rotate: [0, -12, 12, -6, 6, 0]
                            }}
                            transition={{
                                duration: 5.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 0.3
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={7}
                            className="position-absolute"
                            style={{ top: '41%', left: '50%', transform: 'translateX(-50%)' }}
                            animate={{
                                x: [0, 8, -6, 5, -3, 0],
                                y: [0, 12, -8, 6, -4, 0],
                                rotate: [0, 15, -15, 8, -8, 0]
                            }}
                            transition={{
                                duration: 6.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 1.5
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={5}
                            className="position-absolute"
                            style={{ top: '45%', left: '8%' }}
                            animate={{
                                x: [0, 12, -9, 7, -5, 0],
                                y: [0, -8, 6, -4, 3, 0],
                                rotate: [0, -18, 18, -9, 9, 0]
                            }}
                            transition={{
                                duration: 7.5,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 0.8
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={9}
                            className="position-absolute"
                            style={{ top: '50%', right: '8%' }}
                            animate={{
                                x: [0, -10, 8, -6, 4, 0],
                                y: [0, 10, -7, 5, -3, 0],
                                rotate: [0, 12, -12, 6, -6, 0]
                            }}
                            transition={{
                                duration: 5.8,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 1.2
                            }}
                        />

                        <motion.img
                            src={star}
                            alt="star"
                            width={12}
                            className="position-absolute"
                            style={{ bottom: '30%', left: '50%', transform: 'translateX(-50%)' }}
                            animate={{
                                x: [0, -8, 6, -5, 3, 0],
                                y: [0, -10, 7, -5, 3, 0],
                                rotate: [0, 25, -25, 12, -12, 0]
                            }}
                            transition={{
                                duration: 6.8,
                                repeat: Infinity,
                                repeatType: "loop",
                                ease: "easeInOut",
                                delay: 0.6
                            }}
                        />

                        <img
                            src={getEmojiByAngle(angle)}
                            alt="emotion"
                            className="meter-shake"
                            style={{ width: "150px" }}
                        />


                        <Button
                            onClick={() => navigateToNextScreen()}
                            className="rounded-pill border-0 mx-auto GTMedium text-black position-absolute"
                            disabled={!audioBlob}
                            style={{
                                padding: "10px 1px",
                                height: "52px",
                                width: "min(350px, 80vw)",
                                maxWidth: "350px",
                                bottom: '20px',
                                left: '50%',
                                transform: 'translateX(-50%)',
                                background: flowData?.bg || "white",
                                pointerEvents: audioBlob ? 'auto' : 'none',
                                cursor: 'pointer',
                                touchAction: 'none',
                                opacity: 1,
                                WebkitTapHighlightColor: 'transparent',
                            }}
                        >
                            <span className='GTMedium text-black'
                                style={{
                                    fontSize: "clamp(21px, 4.5vw, 27px)",
                                    lineHeight: 1,
                                    whiteSpace: "nowrap",
                                }}
                            >
                                {t?.common?.next || "Next"}
                            </span>
                        </Button>

                    </motion.div>
                )}
            </AnimatePresence>

            {/* Alert Modals - keeping existing ones */}
            {alertModal.show && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        zIndex: 9999,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(8px)'
                    }}
                >
                    <div
                        className="popup-bg rounded-4 p-3 m-3"
                        style={{
                            maxWidth: '420px',
                            width: '90%',
                            boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            className="text-center rounded-4 p-2 mx-auto"
                            style={{
                                maxWidth: "360px",
                            }}
                        >
                            <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    background: "#FFECEC",
                                    fontSize: "22px"
                                }}
                            >
                                🎤
                            </div>

                            <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                {t?.whoTalkin?.micPermissionTitle}
                            </p>

                            <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                {t?.whoTalkin?.micPermissionDesc}
                            </p>

                            <div
                                className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.7",
                                    borderRadius: "12px",
                                    padding: "12px 12px 13px 12px",
                                }}
                            >
                                <h6 className="GTBold text-center popup-main-color">{t?.steps} </h6>
                                <ol className="m-0 my-4 popup-main-color">
                                    <li className="mb-2" >{t?.whoTalkin?.step1.text} <b>{t?.whoTalkin?.step1.bold}</b> {t?.whoTalkin?.step1.text2}</li>
                                    <li className="mb-2" >{t?.whoTalkin?.step2.text} <b>{t?.whoTalkin?.step2.bold}</b> {t?.whoTalkin?.step2.text2}</li>
                                    <li className="mb-2" >{t?.whoTalkin?.step3.text} <b>{t?.whoTalkin?.step3.bold}</b> {t?.whoTalkin?.step3.text2}</li>
                                    <li className="" >{t?.whoTalkin?.step4.text} <b>{t?.whoTalkin?.step4.bold}</b> {t?.whoTalkin?.step4.text2}</li>
                                </ol>
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            <button
                                className="btn fw-semibold"
                                style={{
                                    width: "90%",
                                    backgroundColor: flowData?.bg,
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    padding: '10.px'
                                }}
                                onClick={() => {
                                    setAlertModal({ show: false });
                                    window.location.reload();
                                }}
                            >
                                {t?.whoTalkin?.close}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Alert Modal 2 (iOS) */}
            {alertModal2.show && (
                <div
                    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                    style={{
                        zIndex: 9999,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(8px)'
                    }}
                >
                    <div
                        className="popup-bg rounded-4 p-3 m-3"
                        style={{
                            maxWidth: '420px',
                            width: '90%',
                            boxShadow: '0 20px 55px rgba(0, 0, 0, 0.3)',
                            maxHeight: '90vh',
                            overflowY: 'auto'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div
                            className="text-center rounded-4 p-2 mx-auto"
                            style={{
                                maxWidth: "360px",
                            }}
                        >
                            <div
                                className="d-flex align-items-center justify-content-center mx-auto mb-2"
                                style={{
                                    width: "50px",
                                    height: "50px",
                                    borderRadius: "50%",
                                    background: "#FFECEC",
                                    fontSize: "22px"
                                }}
                            >
                                🎤
                            </div>

                            <p className="mb-2 fw-semibold popup-main-color" style={{ fontSize: "18px" }}>
                                {t?.whoTalkin?.micPermissionTitle}
                            </p>

                            <p className="mb-3" style={{ fontSize: "13px", lineHeight: "1.3", color: "#A7A7A7" }}>
                                {t?.whoTalkin?.micPermissionDesc}
                            </p>

                            <div
                                className="text-start popup-center-bg d-flex flex-column justify-content-around align-items-center popup-border-dashed"
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.7",
                                    borderRadius: "12px",
                                    padding: "12px 12px 13px 12px",
                                }}
                            >
                                <h6 className="GTBold text-center popup-main-color">{t?.whoTalkin?.steps} </h6>
                                <ol className="m-0 my-4 popup-main-color">
                                    <li className="mb-2 popup-main-color ios-item">
                                        <span className="pe-2">{t?.whoTalkin?.ios1.text}</span>
                                        (<b className="icon ios-icon-1"></b>)
                                        <b className="px-2">{t?.whoTalkin?.ios1.bold}</b>
                                        ( <b className="icon ios-icon-2 mx-1"></b> )
                                        <span className="ps-2">{t?.whoTalkin?.ios1.text2}</span>
                                    </li>
                                    <li className="mb-2 popup-main-color">{t?.whoTalkin?.ios2.text} <b>{t?.whoTalkin?.ios2.bold}</b> {t?.whoTalkin?.ios2.text2}</li>
                                    <li className="mb-2 popup-main-color">{t?.whoTalkin?.ios3.text} <b>{t?.whoTalkin?.ios3.bold}</b> {t?.whoTalkin?.ios3.text2}</li>
                                    <li className="popup-main-color">{t?.whoTalkin?.ios4.text} <b>{t?.whoTalkin?.ios4.bold}</b> {t?.whoTalkin?.ios4.text2}</li>
                                </ol>
                            </div>
                        </div>

                        <div className="text-center mt-3">
                            <button
                                className="btn fw-semibold"
                                style={{
                                    width: "90%",
                                    backgroundColor: flowData?.bg,
                                    color: 'white',
                                    borderRadius: '10px',
                                    fontSize: '16px',
                                    padding: '10.px'
                                }}
                                onClick={() => {
                                    setAlertModal2({ show: false });
                                    window.location.reload();
                                }}
                            >
                                {t?.whoTalkin?.close}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <LanguageDropdown subCat={flowData?.subCat} />
        </div>
    );
};

export default FriendVoice;